import React from "react";
import SectionHeading from "./SectionHeading";

const CoachingProcess = ({ t }) => (
  <section id="process" data-testid="coaching-process" className="relative py-16 md:py-24 scroll-mt-16">
    <div className="max-w-6xl mx-auto px-5 lg:px-10">
      <SectionHeading index="02" title={t.processTitle} />
      <ol className="mt-10 md:mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#1E90FF]/15 rounded-2xl overflow-hidden border border-[#1E90FF]/15">
        {t.processSteps.map((s) => (
          <li key={s.step} data-testid={`coaching-step-${s.step}`} className="bg-[#05070B] p-6 md:p-7">
            <div className="font-mono text-xs text-[#A1A7B3] tracking-[0.2em]">
              {t.ui.stepsLabel} <span className="text-[#1E90FF] text-2xl font-bold ml-1">{s.step}</span>
            </div>
            <h3 className="mt-4 text-base md:text-lg font-bold text-[#F3F6FA] leading-snug">{s.title}</h3>
            <p className="mt-2 text-sm text-[#C8CED8] leading-relaxed">{s.body}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default CoachingProcess;
